module.exports = __webpack_public_path__ + "img/half1.9f51899.png";